import { type PostMessageAction, type PostMessagesOptions } from "../types/types";

/**
 * All post messages from inside our iframes and modals should use this function
 * to post messages to the parent window. It strongly types the data and makes
 * sure we're only listening to events that have the iframeUid
 */

export function postMessageFromIframe(action: PostMessageAction): void {
  if (window.self === window.top) {
    return;
  }

  const origin = "*";
  const verificationUrl = new URL(window.location.href);
  const verificationIframeUid = verificationUrl.searchParams.get("verificationIframeUid");

  window.parent.postMessage(
    {
      verificationIframeUid,
      action,
    },
    origin,
  );
}

// Called from the inner iFrame window to let the parent window know about size updates
export function postVerificationSizeUpdates(
  options: PostMessagesOptions = { origin: "*", interval: 100 },
) {
  if (window.self !== window.top) {
    let bodyHeight = document.body.offsetHeight;
    const interval = window.setInterval(() => {
      if (bodyHeight !== document.body.offsetHeight) {
        bodyHeight = document.body.offsetHeight;

        const heightWithComputedMargins =
          bodyHeight +
          parseInt(window.getComputedStyle(document.body).marginTop, 10) +
          parseInt(window.getComputedStyle(document.body).marginBottom, 10);

        postMessageFromIframe({ type: "updateHeight", height: heightWithComputedMargins });
      }
    }, options.interval);

    return () => clearInterval(interval);
  }

  return () => {};
}
